import { EventMessage } from 'src/interfaces/eventMessage';
import { ErrorMessage } from 'src/interfaces/errorMessage';
import { PostMessageKey } from 'src/enums/post-message-key.enum';
const appName = 'exocad-3d-viewer';
export const sendGetContext = () => {
    const eventMessage: EventMessage = {
        eventName: PostMessageKey.GetContext,
        appName,
    };
    window.parent.postMessage(eventMessage, '*');
};

export const sendError = (errorMessage: ErrorMessage) => {
    const eventMessage: EventMessage = {
        eventName: PostMessageKey.Error,
        appName,
        payload: {
            ...errorMessage,
        },
    };
    window.parent.postMessage(eventMessage, '*');
};

export const sendLoadingCompleted = () => {
    const eventMessage: EventMessage = {
        eventName: PostMessageKey.LoadingCompleted,
        appName,
    };
    window.parent.postMessage(eventMessage, '*');
};

export const sendTokenExpired = (sessionId: string) => {
    const eventMessage: EventMessage = {
        eventName: PostMessageKey.TokenExpired,
        appName,
        payload: {
            sessionId,
        },
    };
    window.parent.postMessage(eventMessage, '*');
};
